import type { NodeJson } from "@corca/data";

/**
 * Truncate multi-solution nodes for the phantom hint.
 */
export function truncateNode(node: NodeJson): NodeJson {
  if (node.type === "inline") {
    return {
      ...node,
      props: {},
      children: node.children.map(truncateNode),
    };
  }

  if (
    node.type === "group" &&
    node.children[0].type === "matrix" &&
    node.children[0].props.cols === 1 &&
    node.children[0].props.rows > 1
  ) {
    const matrix = node.children[0];

    return {
      ...node,
      children: [
        {
          ...matrix,
          props: {
            ...matrix.props,
            cols: 2,
            rows: 1,
          },
          children: [
            matrix.children[0],
            {
              type: "inline",
              props: {},
              children: [
                {
                  type: "operatorSymbol",
                  props: {},
                  children: [
                    {
                      type: "symbol",
                      props: { value: "⋯" },
                      children: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  }

  return node;
}
